import { css } from 'lit-element';
// language=CSS
export default css`
  :host {
    display: flex;
    flex-direction: column;
  }

  .line-seperate {
    height: 12px;
  }

  .label {
    margin-bottom: 2px;
  }

  .form-container {
    font-size: 12px;

    color: gray;
  }

  .input {
    width: 80%;
    border: 1px solid #ccc;
    outline: none;
    color: gray;
    height: 20px;
  }

  ki-switcher {
    display: inline-flex;
    border-radius: 0px;
    overflow: hidden;
  }

  .emailInvalid {
    width: 80%;
    border: 1px solid red;
    color: gray;
    outline: none;
    height: 20px;
  }

  .textArea {
    resize: none;

    height: 50px;
  }

  .select {
    width: 305px;
    height: 25px;
    color: gray;
    outline: none;
    border: 1px solid #ccc;
  }

  .kiCheckBox {
    font-size: 14px;
  }

  .tableDiv {
    padding-left: 88px;
  }

  .cancel {
    height: 30px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
    display: table-cell;
  }

  .cancel:hover {
    background-color: var(--theme-color, #0056a0);
    color: white;
    cursor: pointer;
  }

  .submit {
    background-color: var(--theme-color, #0056a0);
    color: white;
    height: 30px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
    display: table-cell;
  }

  .submit:hover {
    background-color: gray;
    color: white;
    cursor: pointer;
  }

  .cancel:hover {
    background-color: gray;
    color: white;
    cursor: pointer;
  }

  .actions{
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
  }
`;
